import React from 'react';
import { Observer } from 'mobx-react';
import { toJS } from 'mobx';
import UseJoyride from './UseJoyride';

const VouchersJoyride = () => {
  return (
    <Observer
      render={() => {
        const steps = [
          {
            title: 'Transactions Page',
            target: '#vouchersStep1',
            content:
              'This view is the detailing of a deal’s transaction. Notice the total, status, when the money is due by, and the transaction details. Here you can edit, update, or explore why there are outstanding balances or payments due on a transaction.',
            disableBeacon: true,
          },
          {
            title: 'Pay Someone',
            target: '#vouchersStep2',
            content:
              'Click here to create a new transaction for a contact that you will be paying',
          },
          {
            title: 'Collect Payment',
            target: '#vouchersStep3',
            content:
              'Click here to create a new transaction for a contact that you will be receiving money from',
          },
          {
            title: 'Filter',
            target: '.filterBtn',
            content:
              'Click the hamburger menu in order to search all your transactions',
          },
          {
            title: 'Select Transaction',
            target: '.react-table',
            content:
              'Click on a transaction to update information, match a payment, or generate a new transaction.',
          },
        ];
        return (
          <UseJoyride passedSteps={steps} customProps={{ continuous: true }} />
        );
      }}
    />
  );
};

export default VouchersJoyride;
